import { useMutation, useQuery } from "@apollo/client";
import {
  Alert,
  Box,
  CircularProgress,
  Snackbar,
  Typography,
} from "@mui/material";
import { AppPageNoTopPadding } from "layouts";
import { UserInfoComponent } from "pages/UserDetails/components/UserInfo";
import { Loader } from "pages/UserDetails/styles";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SEND_ACCESS_NOTIFICATION } from "../UserDetails/queries";
import { AccessNotificationInput } from "../UserDetails/types";
import { GET_SINGLE_DEACTIVATED_USER } from "./queries";
import { Response } from "./types";

export const DeactivatedUserDetails = () => {
  const { id } = useParams();
  const userId: number = parseInt(id ?? "") || 0;
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [showError, setShowError] = useState<boolean>(false);

  const [sendAccessNotification] = useMutation<AccessNotificationInput>(
    SEND_ACCESS_NOTIFICATION,
    {
      variables: {
        accountId: userId,
        accessedBy: localStorage.getItem("username"),
        source: "admin panel",
      },
    }
  );
  useEffect(() => {
    sendAccessNotification();
  }, []);

  const { data, error, loading } = useQuery<Response>(
    GET_SINGLE_DEACTIVATED_USER,
    {
      variables: { userId },
      fetchPolicy: "network-only",
    }
  );

  const account = data?.deactivatedAccount;

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (error) {
      setShowError(true);
    }
  }, [error]);

  return (
    <AppPageNoTopPadding>
      {isLoading || !account ? (
        <Loader>
          <CircularProgress />
        </Loader>
      ) : (
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Box
              sx={{
                margin: "1rem 1rem 0 1rem",
              }}
            >
              <Typography variant="h6">
                {account?.firstName} {account?.lastName}
              </Typography>
              <UserInfoComponent account={account} />
            </Box>
          </Box>
        </Box>
      )}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={showError}
        onClose={() => setShowError(false)}
      >
        <Alert onClose={() => setShowError(false)} severity="error">
          Failed to fetch single deactivated user data.
        </Alert>
      </Snackbar>
    </AppPageNoTopPadding>
  );
};
